import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'appLanguage';
const DEFAULT_LANGUAGE = 'tr-TR';
const SUPPORTED_LANGUAGES = new Set(['tr-TR', 'en-US']);

const LanguageContext = createContext(null);

const normalizeLanguage = (value) => (SUPPORTED_LANGUAGES.has(value) ? value : DEFAULT_LANGUAGE);

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => normalizeLanguage(localStorage.getItem(STORAGE_KEY)));

  const setLanguage = (value) => {
    setLanguageState(normalizeLanguage(value));
  };

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, language);
    document.documentElement.setAttribute('lang', language.startsWith('en') ? 'en' : 'tr');
  }, [language]);

  const value = useMemo(() => ({ language, setLanguage }), [language]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}

